import { render, staticRenderFns } from "./statements-report-filter-dedicated.vue?vue&type=template&id=56b78c98"
import script from "./statements-report-filter-dedicated.vue?vue&type=script&lang=js"
export * from "./statements-report-filter-dedicated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports